export default [
  {
    name: '(UTC-11:00) Midway Island',
    timezone: 'Pacific/Midway',
  },
  {
    name: '(UTC-11:00) Samoa',
    timezone: 'US/Samoa',
  },
  {
    name: '(UTC-10:00) Hawaii',
    timezone: 'US/Hawaii',
  },
  {
    name: '(UTC-09:00) Alaska',
    timezone: 'US/Alaska',
  },
  {
    name: '(UTC-08:00) Pacific Time (US & Canada)',
    timezone: 'US/Pacific',
  },
  {
    name: '(UTC-08:00) Tijuana',
    timezone: 'America/Tijuana',
  },
  {
    name: '(UTC-07:00) Arizona',
    timezone: 'US/Arizona',
  },
  {
    name: '(UTC-07:00) Mountain Time (US & Canada)',
    timezone: 'US/Mountain',
  },
  {
    name: '(UTC-07:00) Chihuahua',
    timezone: 'America/Chihuahua',
  },
  {
    name: '(UTC-07:00) Mazatlan',
    timezone: 'America/Mazatlan',
  },
  {
    name: '(UTC-06:00) Mexico City',
    timezone: 'America/Mexico_City',
  },
  {
    name: '(UTC-06:00) Monterrey',
    timezone: 'America/Monterrey',
  },
  {
    name: '(UTC-06:00) Saskatchewan',
    timezone: 'Canada/Saskatchewan',
  },
  {
    name: '(UTC-06:00) Central Time (US & Canada)',
    timezone: 'US/Central',
  },
  {
    name: '(UTC-05:00) Eastern Time (US & Canada)',
    timezone: 'US/Eastern',
  },
  {
    name: '(UTC-05:00) Indiana (East)',
    timezone: 'US/East-Indiana',
  },
  {
    name: '(UTC-05:00) Bogota',
    timezone: 'America/Bogota',
  },
  {
    name: '(UTC-05:00) Lima',
    timezone: 'America/Lima',
  },
  {
    name: '(UTC-04:30) Caracas',
    timezone: 'America/Caracas',
  },
  {
    name: '(UTC-04:00) Atlantic Time (Canada)',
    timezone: 'Canada/Atlantic',
  },
  {
    name: '(UTC-04:00) La Paz',
    timezone: 'America/La_Paz',
  },
  {
    name: '(UTC-04:00) Santiago',
    timezone: 'America/Santiago',
  },
  {
    name: '(UTC-03:30) Newfoundland',
    timezone: 'Canada/Newfoundland',
  },
  {
    name: '(UTC-03:00) Buenos Aires',
    timezone: 'America/Buenos_Aires',
  },
  {
    name: '(UTC-03:00) Greenland',
    timezone: 'Greenland',
  },
  {
    name: '(UTC-02:00) Stanley',
    timezone: 'Atlantic/Stanley',
  },
  {
    name: '(UTC-01:00) Azores',
    timezone: 'Atlantic/Azores',
  },
  {
    name: '(UTC-01:00) Cape Verde Is.',
    timezone: 'Atlantic/Cape_Verde',
  },
  {
    name: '(UTC) Casablanca',
    timezone: 'Africa/Casablanca',
  },
  {
    name: '(UTC) Dublin',
    timezone: 'Europe/Dublin',
  },
  {
    name: '(UTC) Lisbon',
    timezone: 'Europe/Lisbon',
  },
  {
    name: '(UTC) London',
    timezone: 'Europe/London',
  },
  {
    name: '(UTC) Monrovia',
    timezone: 'Africa/Monrovia',
  },
  {
    name: '(UTC+01:00) Amsterdam',
    timezone: 'Europe/Amsterdam',
  },
  {
    name: '(UTC+01:00) Belgrade',
    timezone: 'Europe/Belgrade',
  },
  {
    name: '(UTC+01:00) Berlin',
    timezone: 'Europe/Berlin',
  },
  {
    name: '(UTC+01:00) Bratislava',
    timezone: 'Europe/Bratislava',
  },
  {
    name: '(UTC+01:00) Brussels',
    timezone: 'Europe/Brussels',
  },
  {
    name: '(UTC+01:00) Budapest',
    timezone: 'Europe/Budapest',
  },
  {
    name: '(UTC+01:00) Copenhagen',
    timezone: 'Europe/Copenhagen',
  },
  {
    name: '(UTC+01:00) Ljubljana',
    timezone: 'Europe/Ljubljana',
  },
  {
    name: '(UTC+01:00) Madrid',
    timezone: 'Europe/Madrid',
  },
  {
    name: '(UTC+01:00) Paris',
    timezone: 'Europe/Paris',
  },
  {
    name: '(UTC+01:00) Prague',
    timezone: 'Europe/Prague',
  },
  {
    name: '(UTC+01:00) Rome',
    timezone: 'Europe/Rome',
  },
  {
    name: '(UTC+01:00) Sarajevo',
    timezone: 'Europe/Sarajevo',
  },
  {
    name: '(UTC+01:00) Skopje',
    timezone: 'Europe/Skopje',
  },
  {
    name: '(UTC+01:00) Stockholm',
    timezone: 'Europe/Stockholm',
  },
  {
    name: '(UTC+01:00) Vienna',
    timezone: 'Europe/Vienna',
  },
  {
    name: '(UTC+01:00) Warsaw',
    timezone: 'Europe/Warsaw',
  },
  {
    name: '(UTC+01:00) Zagreb',
    timezone: 'Europe/Zagreb',
  },
  {
    name: '(UTC+02:00) Athens',
    timezone: 'Europe/Athens',
  },
  {
    name: '(UTC+02:00) Bucharest',
    timezone: 'Europe/Bucharest',
  },
  {
    name: '(UTC+02:00) Cairo',
    timezone: 'Africa/Cairo',
  },
  {
    name: '(UTC+02:00) Harare',
    timezone: 'Africa/Harare',
  },
  {
    name: '(UTC+02:00) Helsinki',
    timezone: 'Europe/Helsinki',
  },
  {
    name: '(UTC+02:00) Istanbul',
    timezone: 'Europe/Istanbul',
  },
  {
    name: '(UTC+02:00) Jerusalem',
    timezone: 'Asia/Jerusalem',
  },
  {
    name: '(UTC+02:00) Kyiv',
    timezone: 'Europe/Kiev',
  },
  {
    name: '(UTC+02:00) Minsk',
    timezone: 'Europe/Minsk',
  },
  {
    name: '(UTC+02:00) Riga',
    timezone: 'Europe/Riga',
  },
  {
    name: '(UTC+02:00) Sofia',
    timezone: 'Europe/Sofia',
  },
  {
    name: '(UTC+02:00) Tallinn',
    timezone: 'Europe/Tallinn',
  },
  {
    name: '(UTC+02:00) Vilnius',
    timezone: 'Europe/Vilnius',
  },
  {
    name: '(UTC+03:00) Baghdad',
    timezone: 'Asia/Baghdad',
  },
  {
    name: '(UTC+03:00) Kuwait',
    timezone: 'Asia/Kuwait',
  },
  {
    name: '(UTC+03:00) Nairobi',
    timezone: 'Africa/Nairobi',
  },
  {
    name: '(UTC+03:00) Riyadh',
    timezone: 'Asia/Riyadh',
  },
  {
    name: '(UTC+03:00) Moscow',
    timezone: 'Europe/Moscow',
  },
  {
    name: '(UTC+03:30) Tehran',
    timezone: 'Asia/Tehran',
  },
  {
    name: '(UTC+04:00) Baku',
    timezone: 'Asia/Baku',
  },
  {
    name: '(UTC+04:00) Volgograd',
    timezone: 'Europe/Volgograd',
  },
  {
    name: '(UTC+04:00) Muscat',
    timezone: 'Asia/Muscat',
  },
  {
    name: '(UTC+04:00) Tbilisi',
    timezone: 'Asia/Tbilisi',
  },
  {
    name: '(UTC+04:00) Yerevan',
    timezone: 'Asia/Yerevan',
  },
  {
    name: '(UTC+04:30) Kabul',
    timezone: 'Asia/Kabul',
  },
  {
    name: '(UTC+05:00) Karachi',
    timezone: 'Asia/Karachi',
  },
  {
    name: '(UTC+05:00) Tashkent',
    timezone: 'Asia/Tashkent',
  },
  {
    name: '(UTC+05:30) Kolkata',
    timezone: 'Asia/Kolkata',
  },
  {
    name: '(UTC+05:45) Kathmandu',
    timezone: 'Asia/Kathmandu',
  },
  {
    name: '(UTC+06:00) Ekaterinburg',
    timezone: 'Asia/Yekaterinburg',
  },
  {
    name: '(UTC+06:00) Almaty',
    timezone: 'Asia/Almaty',
  },
  {
    name: '(UTC+06:00) Dhaka',
    timezone: 'Asia/Dhaka',
  },
  {
    name: '(UTC+07:00) Novosibirsk',
    timezone: 'Asia/Novosibirsk',
  },
  {
    name: '(UTC+07:00) Bangkok',
    timezone: 'Asia/Bangkok',
  },
  {
    name: '(UTC+07:00) Jakarta',
    timezone: 'Asia/Jakarta',
  },
  {
    name: '(UTC+08:00) Krasnoyarsk',
    timezone: 'Asia/Krasnoyarsk',
  },
  {
    name: '(UTC+08:00) Chongqing',
    timezone: 'Asia/Chongqing',
  },
  {
    name: '(UTC+08:00) Hong Kong',
    timezone: 'Asia/Hong_Kong',
  },
  {
    name: '(UTC+08:00) Kuala Lumpur',
    timezone: 'Asia/Kuala_Lumpur',
  },
  {
    name: '(UTC+08:00) Perth',
    timezone: 'Australia/Perth',
  },
  {
    name: '(UTC+08:00) Singapore',
    timezone: 'Asia/Singapore',
  },
  {
    name: '(UTC+08:00) Taipei',
    timezone: 'Asia/Taipei',
  },
  {
    name: '(UTC+08:00) Ulaan Bataar',
    timezone: 'Asia/Ulaanbaatar',
  },
  {
    name: '(UTC+08:00) Urumqi',
    timezone: 'Asia/Urumqi',
  },
  {
    name: '(UTC+09:00) Irkutsk',
    timezone: 'Asia/Irkutsk',
  },
  {
    name: '(UTC+09:00) Seoul',
    timezone: 'Asia/Seoul',
  },
  {
    name: '(UTC+09:00) Tokyo',
    timezone: 'Asia/Tokyo',
  },
  {
    name: '(UTC+09:30) Adelaide',
    timezone: 'Australia/Adelaide',
  },
  {
    name: '(UTC+09:30) Darwin',
    timezone: 'Australia/Darwin',
  },
  {
    name: '(UTC+10:00) Yakutsk',
    timezone: 'Asia/Yakutsk',
  },
  {
    name: '(UTC+10:00) Brisbane',
    timezone: 'Australia/Brisbane',
  },
  {
    name: '(UTC+10:00) Canberra',
    timezone: 'Australia/Canberra',
  },
  {
    name: '(UTC+10:00) Guam',
    timezone: 'Pacific/Guam',
  },
  {
    name: '(UTC+10:00) Hobart',
    timezone: 'Australia/Hobart',
  },
  {
    name: '(UTC+10:00) Melbourne',
    timezone: 'Australia/Melbourne',
  },
  {
    name: '(UTC+10:00) Port Moresby',
    timezone: 'Pacific/Port_Moresby',
  },
  {
    name: '(UTC+10:00) Sydney',
    timezone: 'Australia/Sydney',
  },
  {
    name: '(UTC+11:00) Vladivostok',
    timezone: 'Asia/Vladivostok',
  },
  {
    name: '(UTC+12:00) Magadan',
    timezone: 'Asia/Magadan',
  },
  {
    name: '(UTC+12:00) Auckland',
    timezone: 'Pacific/Auckland',
  },
  {
    name: '(UTC+12:00) Fiji',
    timezone: 'Pacific/Fiji',
  },
];
